@if (timer$ | async; as timer) {
  <span class="op-timer-account-menu--timer"> {{text.tracking}}:  {{ elapsed$ | async }}
    <a
      class="op-timer-account-menu--timer-icon"
      data-test-selector="op-timer-account-menu-stop"
      (click)="stopTimer()"
      >
      <svg op-stopwatch-stop-icon size="small" />
      <span>{{text.stop}}</span>
    </a>
  </span>
  <a
    class="op-timer-account-menu--wp-details"
    uiSref="work-packages.show"
    [uiParams]="{ workPackageId: timer.entity.id }"
    >
    #{{ timer.entity.id }}:  {{ timer.entity.name }}
  </a>
}
